module.exports = __webpack_public_path__ + "img/aijiu.943cde88.png";